import React, { useEffect, useState } from "react";
import { useThemes } from "../Theme/theme";
import CloseIcon from "@mui/icons-material/Close";
import {
  Backdrop,
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  minWidth: "400px",
};

function ConfirmationModal({ open, onClose, onConfirm, title, message }) {
  const { theme } = useThemes();

  const [modalOpen, setModalOpen] = useState(false);
  const controllNavigateState = useSelector(
    (state) => state.controllNavigationSlice
  );

  useEffect(() => {
    if (open) {
      setModalOpen(true);
    }
    if (
      controllNavigateState?.isCustomModalOpen &&
      controllNavigateState?.modalName === "switchCompany"
    ) {
      setModalOpen(true);
    }
  }, [open]);
  return (
    <Modal
      disableRestoreFocus
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={modalOpen}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      onClose={onClose}
    >
      <Fade in={modalOpen}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#ffff",
              }}
            >
              <Box>{title}</Box>
              <IconButton aria-label="delete" onClick={onClose}>
                <CloseIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              padding: "15px",
              // height:{xs:"400px",sm:'auto'},
            }}
          >
            <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
              {message}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              No
            </Button>
            {open && (
              <Button
                onClick={onConfirm}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Yes
              </Button>
            )}
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
}

export default ConfirmationModal;
